import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {INewParcelaSection, IParcela} from "../../../types";
import Estado from "./Estado";
import Caracterizacion from "./Caracterizacion";
import Ubicacion from "./Ubicacion";
import Sectores from "./Sectores";


interface IProps {
    seccion: INewParcelaSection
    parcela: IParcela
    setNombre(nombre: string): void
    setPropietario(propietario: string): void
}

interface IState {
}

class Propiedades extends React.Component<IProps, IState> {
    state: IState = {
    }

    componentDidMount() {
        this.props.setNombre(this.props.parcela.nombre)
        this.props.setPropietario(this.props.parcela.propietario)
    }

    chooseSection = () => {
        switch (this.props.seccion) {
            case 'Caracterización':
                return <Caracterizacion/>;
            case 'Ubicación':
                return <Ubicacion/>;
            case 'Sectores':
                return <Sectores/>;
            default:
                return <div style={{marginTop: 20}}>{`Sección desconocida`}</div>
        }
    };

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignSelf: "start",
                    height: '94vh',
                    width: '100vw'
                }}
            >
                <div style={{width: 300}}>
                    <Estado />
                </div>
                <div style={{width: '100%'}}>
                    {this.chooseSection()}
                </div>
            </div>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    seccion: state.propiedades.seccion,
    parcela: state.propiedades.parcela
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setNombre: (nombre: string) => dispatch({type: "set-propiedades-nombre", nombre}),
    setPropietario: (propietario: string) => dispatch({type: "set-propiedades-propietario", propietario}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Propiedades);
